import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const phoneNumber = '393457845440'; // WhatsApp format: country code + number without +
  
  const whatsappMessage = encodeURIComponent(
    'Ciao! Sono interessato ai vostri servizi di certificazione ISO.'
  );
  
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${whatsappMessage}`;

  return (
    <>
      {/* Floating WhatsApp Button */}
      <div className={`whatsapp-float ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="whatsapp-popup">
            <div className="whatsapp-popup-header">
              <div className="whatsapp-header-content">
                <div className="whatsapp-avatar">
                  <img 
                    src="https://customer-assets-lqy194kg.emergentagent.net/job_iso-compliance-hub-8/artifacts/in3c33x5_1000035409.png" 
                    alt="MCG Logo"
                    className="whatsapp-logo"
                  />
                </div>
                <div className="whatsapp-header-text">
                  <h4>Mallorie Consulting Group</h4>
                  <p>Di solito risponde in pochi minuti</p>
                </div>
              </div>
              <button 
                className="whatsapp-close"
                onClick={() => setIsOpen(false)}
                aria-label="Close chat"
              >
                <X size={20} />
              </button>
            </div>
            <div className="whatsapp-popup-body">
              <div className="whatsapp-message">
                <p>👋 Ciao! Come possiamo aiutarti?</p>
                <span className="whatsapp-time">Ora</span>
              </div>
            </div>
            <div className="whatsapp-popup-footer">
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-start-chat"
              >
                <MessageCircle size={20} />
                <span>Inizia Chat</span>
              </a>
            </div>
          </div>
        )}
        
        <button
          className="whatsapp-button"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Chat on WhatsApp"
        >
          {isOpen ? <X size={24} /> : <MessageCircle size={24} />}
        </button>
      </div>
    </>
  );
};

export default WhatsAppButton;
